var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternStack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 504,
    viewBox: "0 0 402 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1 230.51L221.88 1",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2.77002 249.23L237.53 4.90002",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.85986 262.26L251.28 10.84",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.8398 272.22L266.65 15.04",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.6099 284.53L282.16 19.09",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M36.75 295.38L298.62 22.13",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M45.8198 306.31L311.22 29.28",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M54.8999 317.22L326.64 33.43",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M64.27 327.83L339.18 40.65",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.5298 339.62L349.63 50.11",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M81.9102 350.21L361.41 58.14",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M91.8701 360.19L373.01 66.36",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M100.25 371.84L371.47 88.61",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M131.19 360.7L352.07 131.19",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M132.96 379.41L367.72 135.09",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M140.05 392.45L381.46 141.03",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M150.02 402.41L396.84 145.22",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M157.8 414.71L412.34 149.27",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M166.94 425.57L428.81 152.31",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M176 436.5L441.41 159.47",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M185.09 447.41L456.82 163.62",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M194.45 458.02L469.36 170.84",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M202.72 469.8L479.81 180.29",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M212.09 480.4L491.59 188.33",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M222.05 490.37L503.19 196.55",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M230.44 502.03L501.65 218.8",
    stroke: "#969696",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 0.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternStack2);
export default __webpack_public_path__ + "static/media/pattern-stack-2.44720cc39d070fea1dc3c937603b6fa7.svg";
export { ForwardRef as ReactComponent };